import _uniqueId from "lodash/uniqueId";
import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { formatLocDateMMDDYY } from '@mummssoftware/utils/formatters';
import { getTaggedNoteText } from '@mummssoftware/utils/utils';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';

const NoCpfNotesComponent = ({
  dashboardPrintConfig
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.CPFTableDetailsText, styles.mYPointFiveCm]
}, `${dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate ? defaults.noCpfNotesInDateRange : defaults.noCpfNotes}`));

const CpfNotesUI = ({
  carePlans,
  cpfNotes,
  dashboardPrintConfig
}) => {
  const carePlansById = cpfNotes && Object.keys(cpfNotes);
  const notesUI = carePlansById && carePlansById.map(key => {
    const planById = carePlans && carePlans.reduce((seed, plan) => {
      const id = (plan === null || plan === void 0 ? void 0 : plan.patientNumber) && (plan === null || plan === void 0 ? void 0 : plan.roleGroupName) && `${plan.patientNumber}-${plan.roleGroupName}`;

      if (id) {
        seed[id] = plan;
      }

      return seed;
    }, {});
    const plan = planById && planById[key];
    const title = plan ? `Related Notes to ${plan.discipline} - ${formatLocDateMMDDYY(plan.effectiveDate)}` : `Related Notes`;
    return carePlansById && carePlansById.length && cpfNotes && plan && /*#__PURE__*/React.createElement(View, {
      style: [styles.width50, styles.borderBottomBlack],
      key: _uniqueId('cpf-print-note-')
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.fontWeightBold, styles.fontSizeEightPt, styles.pYPointOneCm]
    }, title), cpfNotes[key].map(note => /*#__PURE__*/React.createElement(Text, {
      style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
    }, getTaggedNoteText(note))));
  }).filter(noteUI => noteUI !== undefined);
  return /*#__PURE__*/React.createElement(View, null, notesUI && notesUI.length > 0 && notesUI || /*#__PURE__*/React.createElement(NoCpfNotesComponent, {
    dashboardPrintConfig: dashboardPrintConfig
  }));
};

export const CpfNotesPDF = ({
  rgHash,
  cpfNotes,
  dashboardPrintConfig
}) => {
  const roleGroups = rgHash && Object.values(rgHash);
  const newPlans = roleGroups && roleGroups.map(roleGroup => Object.values(roleGroup.frequencies).filter(plan => plan.id));
  const carePlans = newPlans && newPlans.flat(); // in case a row is being edited when user goes to ribbon print

  carePlans && carePlans.forEach(plan => {
    plan.editing = false;
  });
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100, styles.mYPointFiveCm]
  }, /*#__PURE__*/React.createElement(CpfNotesUI, {
    cpfNotes: cpfNotes,
    carePlans: carePlans,
    dashboardPrintConfig: dashboardPrintConfig
  }));
};